<button
  (keyup.enter)="toggleShoppingCartHandler()"
  data-testid="shoppingCartIcon"
  [ngClass]="
    getTotalShoppingCartItems() > 0 ? 'fa-stack c-pointer' : 'emptyCart'
  "
  attr.data-count="{{ getTotalShoppingCartItems() }}"
  (click)="toggleShoppingCartHandler()"
  placement="bottom"
  tt_datatestid="shoppingcart-openbutton-tooltip"
  tt_datapendoid="shoppingcart-openbutton-tooltip"
  tt_arialabel="Shopping cart open button tooltip"
  rw-tooltip="Open cart"
>
  <i class="fa-solid fa-cart-shopping shoppingCartIcon + {{ cartClass }}"></i>
</button>
